/**
 * --------------------------------------------------------------------------
 * NJ : Checkbox.js
 * --------------------------------------------------------------------------
 */

import { Data, Manipulator, Testing } from 'nj-utils';
import AbstractFormBaseSelection from './AbstractFormBaseSelection';
import { coreConfig } from 'nj-components/core.config';


/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME = 'checkbox';
const DATA_KEY = `${coreConfig.KEY_PREFIX}.${NAME}`;

const SELECTOR = '.nj-checkbox > label > input[type=checkbox]';

const DEFAULT_CONFIG = {
  template: '<span class="nj-checkbox__decorator"><span class="nj-checkbox__check"></span></span>',
  njFormGroup: {
    required: false
  }
};

class Checkbox extends AbstractFormBaseSelection {
  constructor(element, config, properties) {
    super(Checkbox, element, Manipulator.extend(true, DEFAULT_CONFIG, config), properties);

    this.element = element;

    if (this.element) {
      Data.setData(element, DATA_KEY, this);
    }
  }

  dispose() {
    Data.removeData(this.element, DATA_KEY);
    this.element = null;
  }

  static init(options) {
    return super.init(this, options, SELECTOR);
  }

  static getInstance(element) {
    return Data.getData(element, DATA_KEY);
  }

  static matches(element) {
    return element.getAttribute('type') === 'checkbox';
  }

  static rejectMatch(component, element) {
    Testing.assert(
      this.element,
      this.matches(element),
      `${component} component element ${Testing.describe(
        element
      )} is invalid for type='checkbox'.`
    );
  }

  // Static
  static selector = SELECTOR;
}

export default Checkbox;
